export default {
  dataView: 'Vista de datos',
  close: 'Cerrar',
  refresh: 'Actualizar',
  saveAsImage: 'Guardar como imagen',
  selectAll: 'Seleccionar todo',
  invert: 'Invertir'
}
